import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { ADMIN_ORDER_API_PATHS } from '../constants/orders-api-paths.constant';
import { LabelsData } from './get-labels-by-date.hook';

interface GetOrderLabelsResponse {
  status: string;
  labels: LabelsData;
}

type UseAdminGetOrderLabelsResult = {
  isLoadingLabels: boolean;
  getOrderLabels: (orderId: string) => Promise<LabelsData | null>;
};

export function useAdminGetOrderLabels(): UseAdminGetOrderLabelsResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoadingLabels, setIsLoadingLabels] = useState(false);

  const getOrderLabels = useCallback(
    async (orderId: string): Promise<LabelsData | null> => {
      setIsLoadingLabels(true);
      try {
        const response = await HttpClient.get<GetOrderLabelsResponse>(
          ADMIN_ORDER_API_PATHS.GET_ORDER_LABELS(orderId)
        );
        return response.labels;
      } catch (error) {
        enqueueSnackbar(
          extractApiErrorMessage(error, 'Erreur lors de la récupération des étiquettes'),
          { variant: 'error' }
        );
        return null;
      } finally {
        setIsLoadingLabels(false);
      }
    },
    [enqueueSnackbar]
  );

  return { isLoadingLabels, getOrderLabels };
}
